export default __webpack_public_path__ + "static/media/Flight-and-hotel.096fbc39.svg";